module.exports = {"411726001":"花园街道","411726002":"泌水街道","411726003":"古城街道","411726102":"羊册镇","411726103":"马谷田镇","411726105":"春水镇","411726106":"官庄镇","411726107":"赊湾镇","411726108":"郭集镇","411726109":"泰山庙镇","411726110":"王店镇","411726111":"杨家集镇","411726112":"高店镇","411726113":"高邑镇","411726201":"盘古乡","411726204":"铜山乡","411726206":"下碑寺乡","411726207":"象河乡","411726208":"付庄乡","411726209":"贾楼乡","411726210":"黄山口乡","411726215":"双庙街乡","411726400":"工业园区管委会","411726401":"石材开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411726.json
// module id = 1815
// module chunks = 0